export default __webpack_public_path__ + "static/media/status-online.823efbb7.svg";